import apiClient from './apiClient';

export interface FamilyMember {
  id: number;
  member_email: string | null;
  member_user_id: string | null;
  status: string;
  added_at: string;
  activated_at: string | null;
  removed_at: string | null;
  removal_reason: string | null;
}

export interface FamilyPlanStatus {
  is_owner: boolean;
  is_member: boolean;
  owner_id: string | null;
  owner_email: string | null;
  family_plan_id: number | null;
  max_members: number;
  current_member_count: number;
  members: FamilyMember[];
  subscription_end_date: string | null;
  subscription_status: string;
  plan_status: string | null;
}

export interface AddFamilyMemberRequest {
  member_email: string;
}

export interface AddFamilyMemberResponse {
  success: boolean;
  message: string;
  member: FamilyMember | null;
  was_pending: boolean;
}

export interface RemoveFamilyMemberResponse {
  success: boolean;
  message: string;
}

export interface LeaveFamilyPlanResponse {
  success: boolean;
  message: string;
}

export const familyPlanService = {
  getStatus: async (): Promise<FamilyPlanStatus> => {
    const response = await apiClient.get('/family-plan/status');
    return response.data;
  },

  addMember: async (email: string): Promise<AddFamilyMemberResponse> => {
    const response = await apiClient.post<AddFamilyMemberResponse>('/family-plan/members', {
      member_email: email
    });
    return response.data;
  },

  removeMember: async (memberId: number): Promise<RemoveFamilyMemberResponse> => {
    const response = await apiClient.delete<RemoveFamilyMemberResponse>(`/family-plan/members/${memberId}`);
    return response.data;
  },

  leaveFamilyPlan: async (): Promise<LeaveFamilyPlanResponse> => {
    const response = await apiClient.post<LeaveFamilyPlanResponse>('/family-plan/leave');
    return response.data;
  }
};
